const urlParams = new URLSearchParams(window.location.search);
const initialSearchTerm = urlParams.get('search_term') || '';
const initialPage = parseInt(urlParams.get('page')) || 1;

const searchInput = document.querySelector('input[name="search_api_fulltext_autocomplete"]');
if (searchInput) {
    searchInput.value = initialSearchTerm;
}

const form = document.querySelector('#custom-search-form');
const yearSelect = document.querySelector('#year');
const monthSelect = document.querySelector('#month');
const sortingSelect = document.querySelector('#sorting');
const searchButton = document.querySelector('#search-filter');

yearSelect.addEventListener('change', handleYearChange);
monthSelect.addEventListener('change', () => fetchSearchResults(initialPage));
sortingSelect.addEventListener('change', () => fetchSearchResults(initialPage));
searchButton.addEventListener('click', handleSearch);

fetchSearchResults(initialPage);

function handleYearChange() {
    const yearSelect = document.querySelector('#year');
    const monthSelect = document.querySelector('#month');

    if (yearSelect.value === 'all') {
        monthSelect.disabled = true;
    } else {
        monthSelect.disabled = false;
    }
    monthSelect.value = 'all';
    fetchSearchResults(initialPage);
}

function handleSearch(event) {
    event.preventDefault();
    const searchTerm = searchInput.value.trim();
    const newUrl = new URL(window.location);
    newUrl.searchParams.set('search_term', searchTerm);
    newUrl.searchParams.set('page', 1);
    window.history.pushState({}, '', newUrl);
    fetchSearchResults(1);
}

function fetchSearchResults(page = 1) {
    const searchTerm = new URLSearchParams(window.location.search).get('search_term') || '';
    const year = document.querySelector('select[name="year"]').value || 'all';
    const month = document.querySelector('select[name="month"]').value || 'all';
    const sorting = document.querySelector('select[name="sorting"]').value || 'rel';

    const url = new URL('/ajax/search-results', window.location.origin);
    url.searchParams.set('search_term', searchTerm);
    url.searchParams.set('view_name', 'solr_view');
    url.searchParams.set('view_display', 'more_recent');
    if (year !== 'all') url.searchParams.set('year', year);
    if (month !== 'all') url.searchParams.set('month', month.padStart(2, '0'));
    url.searchParams.set('sort', sorting === 'recent' ? 'date' : 'rel');
    url.searchParams.set('page', page);

    console.log('Fetching URL:', url.toString());

    fetch(url.toString())
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            console.log('Fetched data:', data);
            updateSearchResults(data);
            updatePaginationControls(data.total_pages, page);
            scrollToTop();
        })
        .catch(error => {
            console.error('Error fetching search results:', error);
            displayErrorMessage(error);
        });
}

function updateSearchResults(data) {
    const resultsWrapper = document.querySelector('#results-container');
    resultsWrapper.innerHTML = '';
    const totalResults = data.total_results;
    const searchResults = document.querySelector("#search-results");
    searchResults.textContent = totalResults;

    if (!data.markup || data.markup.trim() === '') {
        displayErrorMessage({ message: 'Δυστυχώς δεν βρέθηκαν αποτελέσματα για τον όρο που αναζητήσατε! Δοκιμάστε να αναζητήσετε κάτι διαφορετικό' });
        return;
    }

    console.log('Rendering markup:', data.markup);
    resultsWrapper.innerHTML = data.markup;
}

function displayErrorMessage(error) {
    const resultsWrapper = document.querySelector('#results-container');
    resultsWrapper.innerHTML = `<div class="error-message">${error.message}</div>`;
}

function updatePaginationControls(totalPages, currentPage) {
    const paginationContainer = document.querySelector('#pagination-container');
    paginationContainer.innerHTML = '';

    if (totalPages <= 1) return;

    const createPageButton = (page, text = page, isDisabled = false, isActive = false) => {
        const button = document.createElement('button');
        button.textContent = text;
        if (button.textContent == 'Prev' && !button.classList.contains("active") ) {
            button.innerHTML = `<svg class="w-4 h-4 mx-auto transition-all duration-200 origin-center rotate-180">
            <use xlink:href="/themes/custom/tw_webpack/dist/images/sprite.svg#arrow"></use>
          </svg>`
            button.classList.add("search-pagination-button")
        } else if (button.textContent == 'Next' && !button.classList.contains("active") ) {
            button.innerHTML = `<svg class="w-4 h-4 mx-auto transition-all duration-200 origin-center">
            <use xlink:href="/themes/custom/tw_webpack/dist/images/sprite.svg#arrow"></use>
          </svg>`
            button.classList.add("search-pagination-button")
        }
        button.disabled = isDisabled;
        if (isActive) button.classList.add('active');
        button.addEventListener('click', () => {
            const newUrl = new URL(window.location);
            newUrl.searchParams.set('page', page);
            window.history.pushState({}, '', newUrl);
            fetchSearchResults(page);
        });
        return button;
    };

    if (currentPage > 1) {
        paginationContainer.appendChild(createPageButton(currentPage - 1, 'Prev'));
    }

    paginationContainer.appendChild(createPageButton(currentPage, currentPage, false, true));

    if (currentPage < totalPages) {
        paginationContainer.appendChild(createPageButton(currentPage + 1, 'Next'));
    }
}

function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}
